//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import loadmore from '@/components/ui/loadmore';
import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import buttonbox from '@/components/ui/buttonbox';

import mainMenuTab from "@/components/mainMenuTab";

export default {
    components: {mainMenuTab,cardbox,navbar,loadmore,buttonbox},
    data(){
        return {

            intergralData: {
                data: [],

            },
            integralCount: 0,
            couponData: [],
            ruleData: [],
        }
    },
    methods:{

        // 兑换说明
        exchangeDetail(item){

            let content = '';

            this.ruleData.forEach(val=>{
                content += `<div style="padding-bottom:10px;">满${val.condition}积分可使用${val.exchange}积分，使用${val.coupon_value*val.ratio}积分兑换${val.coupon_value}元优惠券</div>`
            })

            this.$vux.alert.show({
                title: `${item.store} 积分兑换规则`,
                content: `<div style="text-align:left;">${content}</div>`,
            })

        },

        // 兑换
        exchangeCoupon(item){

            if(item.value > item.origin){
                this.$vux.toast.text('超出最大兑换数量，最大兑换数量为'+item.origin);
                return;
            }

            const opts = {
                url: api.myIntegralExchangeCoupon,
                data: {
                    coupon_id: item.coupon_id,
                    count: item.value,
                },
                type: 'post',
            }
            common.query(opts).then(res=>{
                this.$vux.toast.text("兑换成功");
                this.queryStoreIntegral();
                this.queryIntegralCount();
                this.queryIntegralExchange(item);

            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 查询店铺积分
        queryStoreIntegral(){

            const opts = {
                url: api.myIntergralStore,
                data: {
                    page: 1,
                    size: 100,
                },
                type: 'get',
            }
            common.query(opts).then(res=>{

                res.data.data.map(val=>{
                    val.extend = false;
                })
                this.intergralData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 查询积分总数
        queryIntegralCount(){

            const opts = {
                url: api.myIntegralCount,
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.integralCount = res.data.sum;
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询可兑换优惠卷
        queryIntegralExchange(item){

            // 关闭显示兑换列表
            if(item.extend){
                item.extend = false;
                return;
            }

            const opts = {
                url: api.myIntegralExchangeList,
                data: {
                    store_id: item.store_id,
                },
                type: 'get',
            }
            common.query(opts).then(res=>{

                // 关闭展开的店铺兑换列表
                this.intergralData.data.forEach(val=>{
                    val.extend = false;
                })
                item.extend = true;

                let arr = res.data.filter(val=>{
                    // 转换兑换比例
                    let value =  parseInt(val.coupon_value) * val.ratio ;
                    // 最大可兑换数量
                    val.value = Math.floor( Math.min(val.exchange,item.point) / value );
                    // 保留可兑换数量原值
                    val.origin = val.value;
                    // 过滤不符合兑换条件的数据
                    return parseInt(item.point) >= parseInt(val.condition)
                });
                this.couponData = arr;
                this.ruleData = res.data;

            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

    },
    mounted(){

        this.queryStoreIntegral();
        this.queryIntegralCount();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/integral.vue